import { Services, joinURLPath, regExp } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

const defaultCycle = {
  batch: 100,
  every: 10
}

export default {
  name: 'BatchParams',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    id: String,
    type: String,
    state: String
  },

  data() {
    return {
      proxy: undefined,
      initProxy: undefined,
      loading: false,
      showMenu: false
    }
  },

  computed: {
    canUpdateTasksAsAdmin() {
      return this.checkPermissions(`advanced.${Services.tasks}.update`)
    },

    proxyIsChanged() {
      const normalizedProxy = this.getNormalizedProxy(this.proxy, this.initProxy)
      const normalizedInitProxy = this.getNormalizedProxy(this.initProxy, this.value)

      return normalizedProxy.batch !== normalizedInitProxy.batch || normalizedProxy.every !== normalizedInitProxy.every
    },
    proxyIsDefault() {
      const normalizedProxy = this.getNormalizedProxy(this.proxy, this.initProxy)
      const normalizedDefaultCycle = this.getNormalizedProxy(defaultCycle)

      return normalizedProxy.batch === normalizedDefaultCycle.batch && normalizedProxy.every === normalizedDefaultCycle.every
    }
  },

  watch: {
    showMenu(value) {
      this.$emit('menu', value)
    }
  },

  created() {
    this.setProxy(this.value)
    this.initProxy = this.createProxy(this.value)
  },

  methods: {
    createProxy(value) {
      return {
        batch: value?.batch ?? defaultCycle.batch,
        every: value?.every ?? defaultCycle.every
      }
    },

    normalizePositiveInteger(value, fallbackValue, defaultValue) {
      if (Number.isSafeInteger(value) && value > 0) {
        return value
      }

      if (typeof value === 'string') {
        const trimmedValue = value.trim()
        if (regExp.strictPositiveInteger.test(trimmedValue)) {
          const normalizedValue = Number(trimmedValue)
          if (Number.isSafeInteger(normalizedValue)) {
            return normalizedValue
          }
        }
      }

      if (Number.isSafeInteger(fallbackValue) && fallbackValue > 0) {
        return fallbackValue
      }

      return defaultValue
    },

    getNormalizedProxy(value, fallbackValue) {
      return {
        batch: this.normalizePositiveInteger(value?.batch, fallbackValue?.batch, defaultCycle.batch),
        every: this.normalizePositiveInteger(value?.every, fallbackValue?.every, defaultCycle.every)
      }
    },

    getNormalizedCycle() {
      return this.getNormalizedProxy(this.proxy, this.initProxy)
    },

    setProxy(value) {
      this.proxy = this.createProxy(value)
    },

    resetProxy() {
      this.setProxy(defaultCycle)
    },

    async updateTask() {
      try {
        this.loading = true
        const cycle = this.getNormalizedCycle()
        const data = await request.update(joinURLPath(Services.tasks, this.id), { body: { data: { cycle } } })
        if (data) {
          this.setProxy(data?.data?.cycle)
          this.initProxy = this.createProxy(data?.data?.cycle)
          this.addSnackbar({
            text: this.getTranslate(`${Services.tasks}.snackbars.updated`),
            type: 'success'
          })
          this.showMenu = false
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
